import produce from "immer";

import { readResolvedStore } from "../../util/deliveryContextStorage";

export const Types = {
  SET_SELECTED_STORE: "@storeByUser/SET_SELECTED_STORE",
  SET_RESOLVED_STORE: "@storeByUser/SET_RESOLVED_STORE",
  TOGGLE_OUT_OF_STOCK_MODAL: "@storeByUser/TOGGLE_OUT_OF_STOCK_MODAL",
  CHECK_ITEMS_OUT_OF_STOCK: "@storeByUser/CHECK_ITEMS_OUT_OF_STOCK",
  SET_OUT_OF_STOCK_ITEMS: "@storeByUser/SET_OUT_OF_STOCK_ITEMS",
  DELETE_OUT_OF_STOCK_ITEMS: "@storeByUser/DELETE_OUT_OF_STOCK_ITEMS"
};

export const SELECTED_STORE_KEY = "@ConexaoGAM:selectedStore";

function readLockedStore() {
  try {
    const store = JSON.parse(localStorage.getItem(SELECTED_STORE_KEY));
    if (!store) return null;
    // Registros gravados antes desta versão não têm a marca; farmácia em selectedStore só
    // chega lá por escolha explícita do cliente, então a marca é true.
    return { ...store, selecionadaPeloCliente: true };
  } catch (_) {
    return null;
  }
}

// A farmácia travada tem precedência sobre a resolvida pelo contexto: escolha manual não é
// sobrescrita. A leitura é síncrona, em tempo de import, porque as sagas de products e
// search montam o parâmetro store= na primeira requisição, antes de qualquer saga do
// contexto rodar. Perder essa janela mudaria o comportamento do catálogo inteiro.
const INITIAL_STATE = {
  data: readLockedStore() || readResolvedStore() || null,
  showOutOfStockModal: false,
  outOfStockItems: []
};

export default function storeByUser(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      // Escolha explícita do cliente. A gravação em localStorage e o reload vivem em
      // store/sagas/storeByUser.js — reducer não faz efeito colateral.
      case Types.SET_SELECTED_STORE: {
        const { store } = action.payload;
        draft.data = store ? { ...store, selecionadaPeloCliente: true } : null;
        break;
      }
      // Farmácia eleita pelo contexto de entrega. Não persiste, não recarrega e não dispara
      // o evento de analytics `selecionar_loja`: resolução automática não é escolha.
      case Types.SET_RESOLVED_STORE: {
        const { store } = action.payload;
        draft.data = store
          ? { id: store.id, uuid: store.uuid, selecionadaPeloCliente: false }
          : null;
        break;
      }
      case Types.TOGGLE_OUT_OF_STOCK_MODAL: {
        draft.showOutOfStockModal = !draft.showOutOfStockModal;
        break;
      }
      case Types.SET_OUT_OF_STOCK_ITEMS: {
        draft.outOfStockItems = action.payload.outOfStockItems;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  setStore: (store, reload = true) => ({
    type: Types.SET_SELECTED_STORE,
    payload: { store, reload }
  }),

  setResolvedStore: store => ({
    type: Types.SET_RESOLVED_STORE,
    payload: { store }
  }),

  toggleOutOfStockModal: store => ({
    type: Types.TOGGLE_OUT_OF_STOCK_MODAL
  }),

  checkItemsOutOfStock: () => ({
    type: Types.CHECK_ITEMS_OUT_OF_STOCK
  }),

  setOutOfStockItems: outOfStockItems => ({
    type: Types.SET_OUT_OF_STOCK_ITEMS,
    payload: { outOfStockItems }
  }),

  deleteOutOfStockItems: () => ({
    type: Types.DELETE_OUT_OF_STOCK_ITEMS
  })
};

// Farmácia escolhida pelo cliente, ou null.
//
// O catálogo (products, search, ProductDetail) lê state.storeByUser.data cru, porque ali
// qualquer farmácia que atenda serve para montar store=. Já checkout, modal de itens sem
// estoque e barra superior perguntam outra coisa — "o cliente escolheu uma farmácia?" — e
// precisam deste seletor. O objeto resolvido pelo contexto tem só id e uuid: não tem
// tempo_contingencia_gam nem horário de funcionamento, e quebraria essas telas.
export function selectFarmaciaManual(state) {
  const data = state.storeByUser.data;
  return data && data.selecionadaPeloCliente ? data : null;
}
